import isoDateToString from './isoDateToString';

function isoDateToLocaleShort(isoDate, locale, withTime = false, withWeekday = true) {
  const dateOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };

  if (withTime) {
    dateOptions.hour = '2-digit';
    dateOptions.minute = '2-digit';
  }

  if (withWeekday) {
    dateOptions.weekday = 'long';
  }

  return isoDateToString(isoDate, locale, dateOptions);
}

export default isoDateToLocaleShort;
